module.exports = __webpack_public_path__ + "img/medgate_logo_blue.b1130366.png";